// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"175":"428f8c0c","392":"447ab2b5"}[chunkId] + ".chunk.css";
};